import { Form } from "./forms/form";
import { Amenities, HOPPLER_TIMEZONE } from "../../constants";
import { Listing, Location, KumitaMultimedia } from "../../types";
import moment from "moment-timezone";


// *--A homage to a memory--*
export function createApiInputProperty(form: Form, isDraft?: boolean) {
  let apiProperty: any = {};

  for (let k in form.fields) {
    
    if (form.fields[k].value) {
      if (k === 'category') {
        apiProperty[k] = form.fields[k].value;
      } else if (k === 'division') {
        apiProperty[k] = form.fields[k].value;
      } else if (k === 'type') {

        if (form.fields[k].value === 'Condominium') {
          apiProperty[k] = 'condo';
        } else {
          apiProperty[k] = (form.fields[k].value as string).toLowerCase(); 
        }

      } else if (k === 'bedrooms') {
        apiProperty[k] = Number.parseInt(form.fields[k].value);
      }  else {
        apiProperty[k] = form.fields[k].value;
      }
    } else {
      apiProperty[k] = 0;
    }

  }

  const location = this.state.currentLocation;
  apiProperty.addreArea = location.area;
  apiProperty.addreCity = location.city;
  apiProperty.addreRegion = location.region;
  
  if (location.building) {
    apiProperty.buildingId = location.locationId;
  }

  const locationForm = this.state.locationForm;
  for (let k in locationForm.fields) {
    if (locationForm.fields[k] && locationForm.fields[k].value) {
      apiProperty[k] = locationForm.fields[k].value;
    }
  }

  apiProperty.multimedias = this.state.multimedias;

  if (isDraft) {
    apiProperty.saveAs = 'Draft';
  }

  return apiProperty;

}

// to make it easier to traverse the fields of the passed form
// because we now handle the amenities in a separate loop
const FIELD_SET: string[] = [
  'division',
  'category',
  'type',
  'feStatus',
  'onHoldReason',
  'minLeaseTerm',
  'rentalPrice',
  'salePrice',
  'discountedPrice',
  'pricePerSqm',
  'maxPrice',
  'ownerReceipt',
  'associationDuesIncluded',
  'associationDues',
  'floorArea',
  'lotArea',
  'furnishing',
  'condition',
  'bedrooms',
  'bathrooms',
  'restroom',
  'dateAvailability',
  'dateTurnover',
  // 'parkingSpaces',
  'contactName',
  'contactEmail',
  'contactNumber',
  'notes',

  'tour360Url',
  'videoUrl',
  'liveVideoUrl',
  'preSale',
  'source',
  
];

const BOOLEAN_FIELD_SET: string[] = [
  'associationDuesIncluded',
  'ownerReceipt'
]

export function createKumitaListing(
  form: Form, 
  existingListing?: Listing,
  location?: Location,
  locationForm?: Form,
  multimedia?: KumitaMultimedia[]
) {
  let kumitaListing: Listing;

  if (existingListing) {
    kumitaListing = Object.assign(
      {},
      existingListing
    );
  } else {
    kumitaListing = {};
  }

  kumitaListing.amenities = [];

  let fields = form.fields;

  FIELD_SET.forEach(fieldName => {
    // Explicitly check for undefined, so we let false and 0 through
    if (fields[fieldName] && fields[fieldName].value !== undefined) {
      // Ensure correct formatting of all date fields
      if (fieldName.startsWith('date')) {
        kumitaListing[fieldName] = moment(fields[fieldName].value).tz(HOPPLER_TIMEZONE).format();
      } else {
        kumitaListing[fieldName] = fields[fieldName].value;
      }
    }
  });
  // Please note that there is a unique handling for parkingSpaces
  // Since the value of the checkbox is supposed to open up an
  // input but then be serialized as an array of Amenity,
  // we have this.
  Amenities.forEach(amenity => {
    if (fields[amenity.field] && (fields[amenity.field].value || fields[amenity.field].value == 0) &&
    fields[amenity.field].value != false) {

      if (amenity.field === '__hasParking') {
        kumitaListing.amenities.push(
          {
            field: 'Parking Spaces',
            value: Number.parseInt(fields['parkingSpaces'].value)
          }
        );
      } else {
        kumitaListing.amenities.push(
          {
            field: amenity.label,
            value: fields[amenity.field].value ? 1 : 0
          }
        );
      }      
    }
  });

  if (location) {
    kumitaListing.area = location.area;
    kumitaListing.city = location.city;
    kumitaListing.region = location.region;
  
    if (location.building) {
      kumitaListing.building = location.building;
    }

    if (location.newLocation) {
      kumitaListing.newLocation = 1;
    }
  }

  if (locationForm) {
    for (let k in locationForm.fields) {
      if (k === 'addreNo') {
        if (locationForm.fields[k] && locationForm.fields[k].value) {
          kumitaListing['unitNo'] = locationForm.fields[k].value;
        }
      } else {
        // latitude and longitude are copied here
        if (locationForm.fields[k] && locationForm.fields[k].value) {
          kumitaListing[k] = locationForm.fields[k].value;
        }
      }      
    }
  }

  if (multimedia) {
    kumitaListing.multimedia = multimedia.map(
      m => Object.assign({}, m, { url: undefined })
    );
  }

  // cleanup step
  delete kumitaListing['code'];

  if (kumitaListing.category === 'Sale') {
    kumitaListing.rentalPrice = 0;
  }

  if (kumitaListing.category === 'Rent') {
    kumitaListing.salePrice = 0;
  }

  BOOLEAN_FIELD_SET.forEach(field => {
    kumitaListing[field] = kumitaListing[field] ? 1 : 0;
  });

  return kumitaListing;
}